import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { SiteManagerComponent } from '../site-manager/site-manager.component';
import { MasterCredentialComponent } from '../master-credential/master-credential.component';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { SiteManagementService } from '../site-management.service';
import { Site } from '../site-management-interfaces';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { BuildingManagementService } from 'src/app/building-managment/building-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-site-settings',
  templateUrl: './site-settings.component.html',
  styleUrls: ['./site-settings.component.scss'],
})
export class SiteSettingsComponent implements OnInit, OnDestroy {
  sharedData: any;
  subscription: Subscription | undefined;
  site: any;
  siteAddress: string = '';
  siteTimezone: string = '';
  buildingsList: any;

  constructor(
    public dialogRef: MatDialogRef<SiteSettingsComponent>,
    private sharedDataService: SharedDataService,
    private helperService: HelperService,
    private siteManagementService: SiteManagementService,
    private notificationService: NotificationService,
    private floorManagementService: FloorManagementService,
    private buildingManagementService: BuildingManagementService,
    private localizationService: LocalizationService
  ) {}

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
        this.loadSiteData();
      }
    );
  }

  loadSiteData(): void {
    if (this.sharedData?.selectedSite?.siteId) {
      this.siteManagementService.getAllSites().subscribe({
        next: (sites: Site) => {
          this.site =
            sites &&
            sites.find(
              (site: any) =>
                site.siteId == this.sharedData?.selectedSite?.siteId
            );
          this.siteAddress = this.site?.address;
          this.siteTimezone = this.sharedData?.selectedSite?.siteTimeZone;
        },
        error: (err: Error) => {
          this.notificationService.showError(err?.message);
        },
      });
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  openEditSite(): void {
    this.dialogRef.close();
    const dialogInstance = this.helperService.openModalDialog(
      SiteManagerComponent,
      {
        enableBackOperation: true,
        defaultNavigation: CONSTANTS.SITE,
        noErrorToasterShow: false,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.floorManagementService.setTriggerRerender(true);
      }
      this.buildingManagementService
        .getAllBuildingsBySiteId(this.sharedData?.selectedSite?.siteId)
        .subscribe({
          next: (res: any) => {
            this.buildingsList = res;
            if (this.buildingsList.length <= 0) {
              this.buildingManagementService.buildingsView = false;
            } else this.buildingManagementService.buildingsView = true;
          },
        });
    });
  }

  openMasterCredential(): void {
    this.dialogRef.close();
    this.helperService.openModalDialog(
      SiteManagerComponent,
      {
        enableBackOperation: true,
        defaultNavigation: CONSTANTS.MASTER_CREDENTIAL,
        noErrorToasterShow: false,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
